import { Modal } from '../modals/comps';
import styled from 'styled-components';

export const StyledSandboxModal = styled(Modal)`
  width: 1700px;
  max-height: calc(100% - 40px);
  overflow-y: auto;

  .content {
    overflow-y: auto;
    max-height: calc(100vh - 150px);
  }
`;
